import eventQueue from '../queue';
import { EventAction, EventType } from '../../types/events';
var previousPathname = '/';
var isWizardPath = function (pathname) { return pathname.startsWith('/wizard'); };
function attachEventListeners() {
    eventQueue.on('navigation', function (_a) {
        var historyElement = _a.historyElement, fireAnalyticsEvent = _a.fireAnalyticsEvent, state = _a.state;
        if (!historyElement)
            return;
        if (historyElement.pathname === '/search/search') {
            if (isWizardPath(previousPathname)) {
                fireAnalyticsEvent(EventAction.WIZARD_EXIT, { wizard: state.wizard }, EventType.LINK_WIZARD_EXIT);
            }
        }
        previousPathname = historyElement.pathname;
    });
    eventQueue.on('exit', function (_a) {
        var state = _a.state, fireAnalyticsEvent = _a.fireAnalyticsEvent;
        if (isWizardPath(state.history[0].pathname)) {
            fireAnalyticsEvent(EventAction.WIZARD_EXIT, { wizard: state.wizard }, EventType.LINK_WIZARD_EXIT);
        }
    });
}
attachEventListeners();
